module.exports = __webpack_public_path__ + "static/makine-ogrenimi-98ecffb5be75a36f351822cd8e582ba8.svg";